import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import OnBoarding from "./OnBoarding";
import SetupSendgrid from "./Sendgrid";
import "./style.scss";

const SetupComponent = () => {
  const { setupType } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const validTypes = ["on-boarding", "sendgrid"];
    if (!validTypes.includes(setupType)) {
      navigate("/");
    }
  }, [setupType, navigate]);

  return (
    <div>
      {setupType === "on-boarding" ? (
        <OnBoarding />
      ) : setupType === "sendgrid" ? (
        <SetupSendgrid />
      ) : null}
    </div>
  );
};

export default SetupComponent;
